import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';

import type {
  ExportDeviceInventoryParams,
  GetDeviceInventoryCountRes,
  GetDeviceInventoryParams,
  GetDeviceInventoryRes,
  ExportDeviceInventoryRes,
} from './type';

/**
 * NOTE: v4 のパスは backend マージ + `make gen-api` 後に正規の型解決される。
 * それまでは `apiClient.GET` の path リテラル引数で型エラーが出る箇所がある。
 * Phase 4 では意図的にそのまま記述する。
 */

export const getDeviceInventory = async (
  params: GetDeviceInventoryParams,
): Promise<GetDeviceInventoryRes> => {
  // v4 path 未生成のため、apiClient 側の path リテラル型解決が走らない。
  // backend マージ後に解消する想定。
  const res = await apiClient.GET('/v4/devices', {
    params: {
      query: params,
    },
  });
  return getDataOrThrowApiError(res);
};

export const getDeviceInventoryCount =
  async (): Promise<GetDeviceInventoryCountRes> => {
    const res = await apiClient.GET('/v4/devices-count');
    return getDataOrThrowApiError(res);
  };

export const exportDeviceInventoryCsv = async (
  params: ExportDeviceInventoryParams,
): Promise<ExportDeviceInventoryRes> => {
  const res = await apiClient.GET('/v4/devices-csv/all', {
    params: {
      query: { ...params, mode: 'view', encoding: 'UTF-8' },
    },
  });
  return getDataOrThrowApiError(res);
};
